import { render, staticRenderFns } from "./PayrollChangeRequestDetailDrawer.vue?vue&type=template&id=1c8b42dd&"
import script from "./PayrollChangeRequestDetailDrawer.vue?vue&type=script&lang=ts&"
export * from "./PayrollChangeRequestDetailDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports